module.exports = __webpack_public_path__ + "img/icon-result-2.65f4ba7d.svg";